import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import ptBR from './locales/pt-BR.json'
import enUS from './locales/en-US.json'
import esMX from './locales/es-MX.json'

Vue.use(VueI18n)

export const STORAGE_KEY = 'smg_lang'
export const DEFAULT_LOCALE = 'pt-BR'
export const SUPPORTED_LOCALES = ['pt-BR', 'en-US', 'es-MX']

// Mapeia o idioma do navegador (ex.: "es-AR", "en-GB", "pt") para um idioma suportado.
function matchLocale(candidate) {
  if (!candidate) return null
  const exact = SUPPORTED_LOCALES.find(l => l.toLowerCase() === candidate.toLowerCase())
  if (exact) return exact
  const lang = candidate.split('-')[0].toLowerCase()
  return SUPPORTED_LOCALES.find(l => l.split('-')[0].toLowerCase() === lang) || null
}

function initialLocale() {
  try {
    const saved = matchLocale(localStorage.getItem(STORAGE_KEY))
    if (saved) return saved
  } catch (e) { /* localStorage indisponível */ }
  return matchLocale(navigator.language) || DEFAULT_LOCALE
}

const i18n = new VueI18n({
  locale: initialLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: { 'pt-BR': ptBR, 'en-US': enUS, 'es-MX': esMX },
  silentFallbackWarn: true
})

// Aplica o idioma na UI, no <html lang> e no cabeçalho Accept-Language
// enviado ao backend (smgws resolve as mensagens por esse cabeçalho).
export function setLocale(locale) {
  const target = matchLocale(locale) || DEFAULT_LOCALE
  i18n.locale = target
  axios.defaults.headers.common['Accept-Language'] = target
  document.documentElement.setAttribute('lang', target)
  try { localStorage.setItem(STORAGE_KEY, target) } catch (e) { /* ignore */ }
  return target
}

setLocale(i18n.locale)

export default i18n
